/**
 * Detects browser support for the File System Access API.
 * The agent's local-fs tools require `showDirectoryPicker` and the
 * `FileSystemDirectoryHandle` interface, which are Chromium-only at present.
 *
 * @module file-agent/lib/browser-support
 */

/**
 * True when the current browser exposes the File System Access API surface
 * the file agent needs (directory picker + handle persistence).
 */
export function isFileSystemAccessSupported(): boolean {
  if (typeof window === "undefined") return false;
  return (
    typeof (window as unknown as { showDirectoryPicker?: unknown })
      .showDirectoryPicker === "function"
  );
}
